function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M7.42 0H2.642C1.158 0 .035 1.108 0 2.497l.001.16.013.164C.152 4.115 1.233 5.084 2.64 5.084h2.785l4.193 12.919.008.045c.27 1.07 1.302 1.805 2.445 1.805H25.34c1.076 0 1.94-.556 2.423-1.479l3.574-6.155.065-.102.127-.223.23-.431c.09-.169.15-.345.184-.527.566-3.075-3.224-4.114-4.996-1.605l-.151.22-.264.407-.201.323-.462.767-.26.445-.74 1.293-1.104 1.982h-9.688L10.013 1.843C9.522.66 8.643 0 7.421 0z",
  transform: "translate(-764 -439) translate(644 426.5) translate(120.289 13)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.446 21.338c2.305 0 4.068 1.852 4.068 3.97 0 2.25-1.763 3.97-4.068 3.97-2.17 0-3.932-1.72-3.932-3.97 0-2.117 1.763-3.97 3.932-3.97z",
  transform: "translate(-764 -439) translate(644 426.5) translate(120.289 13) rotate(.2 13.514 25.308)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.104 21.338c2.267 0 4 1.852 4 3.97 0 2.25-1.733 3.97-4 3.97-2.133 0-4-1.72-4-3.97 0-2.117 1.867-3.97 4-3.97z",
  transform: "translate(-764 -439) translate(644 426.5) translate(120.289 13) rotate(.2 23.104 25.308)"
})))));

var SvgIconSepetWhite = function SvgIconSepetWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSepetWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-sepet-white.cea65f16.svg";
export { ForwardRef as ReactComponent };